import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MobileHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 5.5H7m11 13H7M10.318 9A1.82 1.82 0 0 1 12 10.131 1.82 1.82 0 0 1 13.685 9a1.99 1.99 0 0 1 1.82 2.009C15.505 13.21 12.467 15 12 15s-3.505-1.79-3.505-3.991A1.99 1.99 0 0 1 10.318 9M18.5 19.5v-15a2 2 0 0 0-2-2h-9a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MobileHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
